import React from 'react'
import propTypes from 'prop-types'

export const Skeleton = React.memo(({ length, className, style={}, parentClassName}) => {
    return (
        <div className={`${parentClassName}`}>
          {Array.from({ length }, (_, index) => index + 1).map((number) => 
            <div key={number} style={style} className={`${className} bg-gray-200 animate-pulse dark:bg-gray-700`}></div>)}
        </div>
    )
})

Skeleton.propTypes ={
    length:propTypes.number,
    className:propTypes.string,
    parentClassName:propTypes.string,
    style:propTypes.object,
}
Skeleton.defaultProps = {
    length:1,
    className:' h-2.5 rounded-full w-48 mb-4',
    parentClassName:'w-full',
    style:{}
}